/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {DropdownOptionModel} from '../models/dropdown-option.model';

@Component({
    selector: 'app-tree-dropdown',
    templateUrl: './tree-dropdown.component.html',
    styleUrls: ['./tree-dropdown.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TreeDropdownComponent implements OnInit {

    @Input() dropdownOptions: DropdownOptionModel[] = [];
    @Output() selectedOption = new EventEmitter<DropdownOptionModel>();

    public show = false;

    constructor() {
    }

    ngOnInit(): void {
    }

    toggleChildren(code: DropdownOptionModel): void {
        code.isOpen = !code.isOpen;
    }

    selectOption(option: DropdownOptionModel, father: string): void {
        option.extra = father;
        this.selectedOption.emit(option);
    }
}
